import React from 'react';

import cx from 'classnames';

import s from './Spinner.module.css';

/**
 * Spinner is an animated circular icon used to indicate a busy state
 *
 * By default, the icon will take the intrinsic color and text size of its container
 */
export const Spinner = ({ className }: { className?: string }) => (
  <span className={cx(className, s.root)} aria-busy="true" aria-live="polite" />
);
